import { render, staticRenderFns } from "./AdsBanner.vue?vue&type=template&id=b9b3930c"
import script from "./AdsBanner.vue?vue&type=script&lang=js"
export * from "./AdsBanner.vue?vue&type=script&lang=js"
import style0 from "./AdsBanner.vue?vue&type=style&index=0&id=b9b3930c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports